'use strict';
import * as $j_app$002edata$002e$002dApp$002dAuth$002dData$0024 from "./app.data.-App-Auth-Data$.js";
import * as $j_app$002edata$002eauth$0024package$0024$002dApp$002dAuth$002dError$0024 from "./app.data.auth$package$-App-Auth-Error$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $p_Lapp_Endpoints$__authErrorBody__Lsttp_tapir_EndpointOutput($thiz) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_EndpointOutput__and__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointOutput($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_json_circe_TapirJsonCirce__jsonBody__Lio_circe_Encoder__Lio_circe_Decoder__Lsttp_tapir_Schema__Lsttp_tapir_EndpointIO$Body($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_tapir_FrameworkTapir$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fcirce$package$().J($j_app$002edata$002eauth$0024package$0024$002dApp$002dAuth$002dError$0024.$m_Lapp_data_auth$package$AppAuthError$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().G, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().F), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fcirce$package$().J($j_app$002edata$002eauth$0024package$0024$002dApp$002dAuth$002dError$0024.$m_Lapp_data_auth$package$AppAuthError$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().G, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().F), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3ftapir$package$().ae($j_app$002edata$002eauth$0024package$0024$002dApp$002dAuth$002dError$0024.$m_Lapp_data_auth$package$AppAuthError$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$().ab)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_Tapir__statusCode__I__Lsttp_tapir_EndpointOutput$FixedStatusCode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_tapir_FrameworkTapir$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_model_StatusCode$().ap7), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat3$$anon$7(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21()));
}
export { $p_Lapp_Endpoints$__authErrorBody__Lsttp_tapir_EndpointOutput as $p_Lapp_Endpoints$__authErrorBody__Lsttp_tapir_EndpointOutput };
function $p_Lapp_Endpoints$__securedEndpoint__Lsttp_tapir_EndpointOutput__Lsttp_tapir_Endpoint($thiz, errorOut) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_EndpointErrorOutputsOps__errorOut__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__O($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_EndpointSecurityInputsOps__securityIn__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__O($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_tapir_FrameworkTapir$().al0, ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_tapir_FrameworkTapir$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_TapirAuth$()).bOm("Bearer", ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_model_headers_WWWAuthenticateChallenge$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_model_headers_WWWAuthenticateChallenge$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_model_headers_WWWAuthenticateChallenge$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_model_headers_WWWAuthenticateChallenge("Bearer", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_ListMap$EmptyListMap$())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Codec$().bPW($j_app$002edata$002e$002dApp$002dAuth$002dData$0024.$m_Lapp_data_AppAuthData$().kt())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21())), errorOut, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21()));
}
export { $p_Lapp_Endpoints$__securedEndpoint__Lsttp_tapir_EndpointOutput__Lsttp_tapir_Endpoint as $p_Lapp_Endpoints$__securedEndpoint__Lsttp_tapir_EndpointOutput__Lsttp_tapir_Endpoint };
function $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$3$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$3$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$3$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$3$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$6$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$6$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$6$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$6$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$9$$_$allTypeArguments$3__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$9$$_$allTypeArguments$3__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$9$$_$allTypeArguments$3__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$9$$_$allTypeArguments$3__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$12$$_$allTypeArguments$4__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$12$$_$allTypeArguments$4__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$12$$_$allTypeArguments$4__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$Documents$$anon$12$$_$allTypeArguments$4__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$15$$_$allTypeArguments$5__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$15$$_$allTypeArguments$5__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$15$$_$allTypeArguments$5__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$15$$_$allTypeArguments$5__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$18$$_$allTypeArguments$6__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$18$$_$allTypeArguments$6__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$18$$_$allTypeArguments$6__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$18$$_$allTypeArguments$6__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$21$$_$allTypeArguments$7__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$21$$_$allTypeArguments$7__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$21$$_$allTypeArguments$7__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$21$$_$allTypeArguments$7__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$24$$_$allTypeArguments$8__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$24$$_$allTypeArguments$8__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$24$$_$allTypeArguments$8__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$DocumentAuditLogs$$anon$24$$_$allTypeArguments$8__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$27$$_$allTypeArguments$9__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$27$$_$allTypeArguments$9__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$27$$_$allTypeArguments$9__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$27$$_$allTypeArguments$9__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$30$$_$allTypeArguments$10__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$30$$_$allTypeArguments$10__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$30$$_$allTypeArguments$10__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$30$$_$allTypeArguments$10__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$33$$_$allTypeArguments$11__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$33$$_$allTypeArguments$11__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$33$$_$allTypeArguments$11__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$33$$_$allTypeArguments$11__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$36$$_$allTypeArguments$12__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$36$$_$allTypeArguments$12__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$36$$_$allTypeArguments$12__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$ExternalDocuments$$anon$36$$_$allTypeArguments$12__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$39$$_$allTypeArguments$13__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$39$$_$allTypeArguments$13__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$39$$_$allTypeArguments$13__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$39$$_$allTypeArguments$13__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$42$$_$allTypeArguments$14__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$42$$_$allTypeArguments$14__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$42$$_$allTypeArguments$14__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$42$$_$allTypeArguments$14__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$45$$_$allTypeArguments$15__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$45$$_$allTypeArguments$15__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$45$$_$allTypeArguments$15__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$45$$_$allTypeArguments$15__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$48$$_$allTypeArguments$16__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.bA.a2();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$())) {
    var arg1 = rest.H();
    var it = $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$48$$_$allTypeArguments$16__Lmagnolia1_TypeInfo__sci_Seq(arg1).b2(arg1).r();
    while (it.l()) {
      var nx = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_$colon$colon(it.k(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.ac = nx;
      }
      t = nx;
    }
    rest = rest.K();
  }
  return ((h === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$() : h);
}
export { $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$48$$_$allTypeArguments$16__Lmagnolia1_TypeInfo__sci_Seq as $s_Lapp_Endpoints$__app$Endpoints$DocumentTemplates$$anon$48$$_$allTypeArguments$16__Lmagnolia1_TypeInfo__sci_Seq };
/** @constructor */
function $c_Lapp_Endpoints$() {
  this.kG = null;
  this.ahk = null;
  this.avz = null;
  $n_Lapp_Endpoints$ = this;
  this.kG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_Tapir__stringToPath__T__Lsttp_tapir_EndpointInput$FixedPath($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_tapir_FrameworkTapir$(), "api");
  this.ahk = "auth";
  this.avz = "X-Gotenberg-Secret";
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_EndpointOutputsOps__out__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__O($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_EndpointInputsOps__in__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__O($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_EndpointInputsOps__method__T__O($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_tapir_FrameworkTapir$().al1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_model_Method$().pj), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_EndpointInput__and__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__Lsttp_tapir_EndpointInput(this.kG, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_Tapir__stringToPath__T__Lsttp_tapir_EndpointInput$FixedPath($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_tapir_FrameworkTapir$(), "test-decode-error"), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_ParamConcat$$anon$1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_typelevel_ParamConcat$())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_ParamConcat$$anon$1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_typelevel_ParamConcat$())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_json_circe_TapirJsonCirce__jsonBody__Lio_circe_Encoder__Lio_circe_Decoder__Lsttp_tapir_Schema__Lsttp_tapir_EndpointIO$Body($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_tapir_FrameworkTapir$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().wX, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().wW, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Schema$().In), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21()));
}
export { $c_Lapp_Endpoints$ as $c_Lapp_Endpoints$ };
$p = $c_Lapp_Endpoints$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_Endpoints$;
/** @constructor */
function $h_Lapp_Endpoints$() {
}
export { $h_Lapp_Endpoints$ as $h_Lapp_Endpoints$ };
$h_Lapp_Endpoints$.prototype = $p;
$p.aq5 = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_EndpointErrorOutputsOps__errorOut__Lsttp_tapir_EndpointOutput__Lsttp_tapir_typelevel_ParamConcat__O($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_EndpointSecurityInputsOps__securityIn__Lsttp_tapir_EndpointInput__Lsttp_tapir_typelevel_ParamConcat__O($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_tapir_FrameworkTapir$().al0, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_Tapir__cookie__T__Lsttp_tapir_Codec__Lsttp_tapir_EndpointInput$Cookie($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_tapir_FrameworkTapir$(), this.ahk, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Codec$().bSc($m_Lapp_data_CookieAppAuthData$().kt())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21())), $p_Lapp_Endpoints$__authErrorBody__Lsttp_tapir_EndpointOutput(this), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_LowPriorityTupleConcat4$$anon$5(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsttp_tapir_typelevel_LowPriorityTupleArity$$anon$21()));
});
var $d_Lapp_Endpoints$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_Endpoints$, "app.Endpoints$", ({
  x2: 1
}));
export { $d_Lapp_Endpoints$ as $d_Lapp_Endpoints$ };
var $n_Lapp_Endpoints$;
function $m_Lapp_Endpoints$() {
  if ((!$n_Lapp_Endpoints$)) {
    $n_Lapp_Endpoints$ = new $c_Lapp_Endpoints$();
  }
  return $n_Lapp_Endpoints$;
}
export { $m_Lapp_Endpoints$ as $m_Lapp_Endpoints$ };
/** @constructor */
function $c_Lapp_data_CookieAppAuthData$() {
  this.aAq = null;
  this.aAr = false;
  this.aAp = null;
  this.aAn = null;
  this.aAo = false;
  $n_Lapp_data_CookieAppAuthData$ = this;
  this.aAp = $j_app$002edata$002e$002dApp$002dAuth$002dData$0024.$m_Lapp_data_AppAuthData$().axt;
}
export { $c_Lapp_data_CookieAppAuthData$ as $c_Lapp_data_CookieAppAuthData$ };
$p = $c_Lapp_data_CookieAppAuthData$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_CookieAppAuthData$;
/** @constructor */
function $h_Lapp_data_CookieAppAuthData$() {
}
export { $h_Lapp_data_CookieAppAuthData$ as $h_Lapp_data_CookieAppAuthData$ };
$h_Lapp_data_CookieAppAuthData$.prototype = $p;
$p.brP = (function() {
  if ((!this.aAr)) {
    this.aAq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_CookieNameFor($m_Lapp_Endpoints$().ahk);
    this.aAr = true;
  }
  return this.aAq;
});
$p.kt = (function() {
  if ((!this.aAo)) {
    this.aAn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec($j_app$002edata$002e$002dApp$002dAuth$002dData$0024.$m_Lapp_data_AppAuthData$().kt(), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((data) => new $c_Lapp_data_CookieAppAuthData(($m_Lapp_data_CookieAppAuthData$(), data)))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$2) => ((_$2 === null) ? null : _$2.oU))));
    this.aAo = true;
  }
  return this.aAn;
});
$p.bHK = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lapp_data_CookieAppAuthData)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.oU);
    return ((this$ === null) ? (x$0$2 === null) : this$.f(x$0$2));
  } else {
    return false;
  }
});
$p.bYd = (function(this$) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(new $c_Lapp_data_CookieAppAuthData(this$));
});
$p.bTF = (function(this$, n) {
  if ((n === 0)) {
    return this$;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.bTJ = (function(this$, n) {
  if ((n === 0)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lapp_data_CookieAppAuthData$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_CookieAppAuthData$, "app.data.CookieAppAuthData$", ({
  D5: 1
}));
export { $d_Lapp_data_CookieAppAuthData$ as $d_Lapp_data_CookieAppAuthData$ };
var $n_Lapp_data_CookieAppAuthData$;
function $m_Lapp_data_CookieAppAuthData$() {
  if ((!$n_Lapp_data_CookieAppAuthData$)) {
    $n_Lapp_data_CookieAppAuthData$ = new $c_Lapp_data_CookieAppAuthData$();
  }
  return $n_Lapp_data_CookieAppAuthData$;
}
export { $m_Lapp_data_CookieAppAuthData$ as $m_Lapp_data_CookieAppAuthData$ };
/** @constructor */
function $c_Lapp_data_CookieAppAuthData(data) {
  this.oU = null;
  this.oU = data;
}
export { $c_Lapp_data_CookieAppAuthData as $c_Lapp_data_CookieAppAuthData };
$p = $c_Lapp_data_CookieAppAuthData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_CookieAppAuthData;
/** @constructor */
function $h_Lapp_data_CookieAppAuthData() {
}
export { $h_Lapp_data_CookieAppAuthData as $h_Lapp_data_CookieAppAuthData };
$h_Lapp_data_CookieAppAuthData.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  $m_Lapp_data_CookieAppAuthData$();
  var this$ = this.oU;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this$, (-889275714), false);
});
$p.f = (function(x$0) {
  return $m_Lapp_data_CookieAppAuthData$().bHK(this.oU, x$0);
});
$p.n = (function() {
  return $m_Lapp_data_CookieAppAuthData$().bYd(this.oU);
});
$p.s = (function() {
  $m_Lapp_data_CookieAppAuthData$();
  return 1;
});
$p.t = (function() {
  $m_Lapp_data_CookieAppAuthData$();
  return "CookieAppAuthData";
});
$p.e = (function(n) {
  return $m_Lapp_data_CookieAppAuthData$().bTF(this.oU, n);
});
$p.u = (function(n) {
  return $m_Lapp_data_CookieAppAuthData$().bTJ(this.oU, n);
});
function $isArrayOf_Lapp_data_CookieAppAuthData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jk)));
}
export { $isArrayOf_Lapp_data_CookieAppAuthData as $isArrayOf_Lapp_data_CookieAppAuthData };
var $d_Lapp_data_CookieAppAuthData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_CookieAppAuthData, "app.data.CookieAppAuthData", ({
  jk: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_CookieAppAuthData as $d_Lapp_data_CookieAppAuthData };
//# sourceMappingURL=app.-Endpoints$.js.map
